<div
    class="miles-editable miles-card padded"
    *ngIf="!isEditing && trucker.Id > 0"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    (click)="edit()"
    [style.cursor]="canEdit ? 'pointer' : 'default'"
>
    <h4>
        Driver Info
        <span class="pull-right" *ngIf="canEdit" [hidden]="!isHovered">
            <i class="fa fa-lg fa-edit"></i>
        </span>
    </h4>
    <mt-dynamic-view [config]="viewOnly"></mt-dynamic-view>
</div>
<div *ngIf="isEditing" class="miles-form padded">
    <h4>Driver Info</h4>
    <mt-dynamic-form [config]="formObject" (submitted)="formSubmitted($event)" (formCreated)="formCreated($event)">
        <br>
        <button type="submit" mtDisableClickDuringHttpCalls Class="btn btn-flat btn-success">Save</button>
        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
        <button type="button" Class="btn btn-flat btn-danger" [routerLink]="['/truckers/' + trucker.Id + '/ban-history']">
            Driver Ban History
        </button>
    </mt-dynamic-form>
</div>
